<template>
  <section>
    <v-card>
      <v-card-title class="chart-title" primary-title>
        Teacher Usage
      </v-card-title>
      <v-card-actions>
        <v-select
          :items="dropDown"
          label="View Teacher activity"
          class="mainGraphSelect pl-3 pt-4"
          v-model="dropDownSelection"
        ></v-select>
        <report-date-picker
          class="mx-3"
          :prop-date-from="dateFrom"
          :prop-date-to="dateTo"
          @dateToSelected="dateToSelected"
          @dateFromSelected="dateFromSelected"
        />
        <v-spacer />
      </v-card-actions>
      <line-chart
        v-if="activityData"
        :chart-data="activityData"
        :options="options"
        class="chart-layout pl-2 pb-2 pr-2"
      />
    </v-card>
  </section>
</template>

<script>
import ReportDatePicker from '@/modules/client/views/reports/ReportDatePicker'
import ReportsMixin from '@/modules/client/views/reports/reports-mixin'
import LineChart from '../charts/LineChart'

export default {
  components: {
    ReportDatePicker,
    LineChart
  },
  mixins: [ReportsMixin],
  async mounted() {
    this.type = 'loginData'
    await this.searchItems()
  },
  data: () => ({
    dropDown: [
      { text: 'Teacher Registration', value: 'teacherRegistrationDataset' },
      { text: 'Teacher Login', value: 'teacherLoginDataSet' }
      // { text: 'Students', value: 'studentDataset' }
    ],
    dropDownSelection: 'teacherRegistrationDataset',
    options: {
      maintainAspectRatio: false
    },
    items: {}
  }),
  watch: {
    async dropDownSelection(value) {
      this.type = value.value
      await this.searchItems()
    }
  },
  computed: {
    activityData() {
      if (!this.items) return null
      let obj =
        this.items[this.dropDownSelection] !== undefined
          ? this.items[this.dropDownSelection]
          : null
      return JSON.parse(JSON.stringify(obj))
    }
  }
}
</script>

<style lang="scss" scoped>
.mainGraphSelect {
  font-size: 14px !important;
  width: 30%;
}

.chart-layout {
  height: 300px !important;
}
</style>
